type Env = 'dev' | 'prod';

const env = {
  QUESTIONNAIRE_API_URL: process.env.REACT_APP_QUESTIONNAIRE_API_URL,
  LAUNCHDARKLY_ID: process.env.REACT_APP_LAUNCHDARKLY_ID,
  SITE_URL: process.env.REACT_APP_SITE_URL,
  LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT as Env,
  TV_URL: process.env.REACT_APP_TV_URL,
  COMMUNITY_URL: process.env.REACT_APP_COMMUNITY_URL,
  CANCEL_FLOW_API_URL: process.env.REACT_APP_CANCEL_FLOW_API_URL,
  CUSTOMIZE_API_URL: process.env.REACT_APP_CUSTOMIZE_API_URL,
  ACE_API_URL: process.env.REACT_APP_ACE_API_URL,
  ASADO_URL: process.env.REACT_APP_ASADO_BASE_URL,
  BOXSTATE_API_URL: process.env.REACT_APP_BOX_API_URL,
  GROWTH_API_URL: process.env.REACT_APP_GROWTH_API_URL,
  CHATBOT_AGENT_ID: process.env.REACT_APP_APPLIED_LABS_AGENT_ID,
};

export default env;
